import "./App.css";
import "antd/dist/reset.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SiderDemo from "./components/Layout/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import { connect, Provider } from "react-redux";
import store from "./store/store";
import "@fontsource/lato";
import LeadGenerationAnalytics from "./pages/Dashboard";
import TransactionPage from "./pages/Transactions";
import MyLeads from "./pages/MyLeads";
import MyLeadsBusiness from "./pages/MyLeadsBusiness";
import RegistrationPage from "./pages/Registration";
import AdminDashboard from "./pages/AdminDashboard";
import Businesses from "./pages/Businesses";
import RedirectMail from "./pages/RedirectMail";
import Password from "./pages/Password";
import Test from "./pages/Test";
import Login from "./pages/login";
import { useEffect } from "react";
import { setUser } from "./store/action/common/authAction";
import Tickets from "./pages/Tickets";
import Setting from "./pages/Setting";
import Helpdesk from "./pages/Helpdesk";
import MySubscriptiontable from "./pages/MySubscriptiontable";
import SubscriptionMaster from "./pages/SubscriptionMaster";
import Customizedplan from "./pages/Customizedplan";
import SubscriptionBill from "./pages/SubscriptionBill";
import UtmMapping from "./pages/UtmMapping";
import UtmMappingForm from "./pages/UtmMappingForm";
import UpgradePlan from "./pages/UpgradePlan";
import MyProfile from "./pages/MyProfile";
import BandLMapping from "./pages/BandLMapping";
import LeadBulkUpload from "./pages/LeadBulkUpload";
import ForgotPassword from "./components/Modals/ForgotPassword";
import NewDashboard from "./pages/NewDashboard/NewDashboard";
import FilterLeads from "./pages/NewDashboard/FilterLeads";
import PreviewCart from "./pages/Cart/PreviewCart";
// import BeforeLoginWeb from "./pages/NewDashboard/BeforeLoginWeb";
import AfterLogin from "./pages/NewDashboard/AfterLogin";
import MyCart from "./pages/Cart/MyCart";
import Checkout from "./pages/Cart/CheckoutPage";
import PaymentSuccess from "./pages/Cart/PaymentSuccess";
import PaymentFailure from "./pages/Cart/PaymentFailure";
import AfterLoginWeb from "./pages/NewDashboard/AfterLoginWeb";
import AfterLoginMobile from "./pages/NewDashboard/AfterLoginMobile";
// import BeforeLoginMobile from "./pages/NewDashboard/BeforeLoginMobile";
import BeforeLogin from "./pages/NewDashboard/BeforeLogin";
import BulkUploadLeads from "./pages/NewDashboard/BulkUploadLeads";
import Finalform from "./pages/Signup/Signup";
import NewUserDashboardWeb from "./pages/NewDashboard/NewUserDashboardWeb";
import RetailAdminDashboard from "./pages/NewDashboard/RetailAdminDashboard";
import RetailMyLeads from "./pages/BusinessNewPages/RetailPages/RetailMyLeads";
import RetailTransactionsHistory from "./pages/BusinessNewPages/RetailPages/RetailTransactionsHistory";
import NewUserDashboard from "./pages/NewDashboard/NewUserDashboard";
import NewUserDashboardMobile from "./pages/NewDashboard/NewUserDashboardMobile";
import MyLeadsBusinessRetailWeb from "./pages/NewDashboard/MyLeadsBusinessRetailWeb";
import MyLeadsBusinessRetailMobile from "./pages/NewDashboard/MyLeadsBusinessRetailMobile";
import MyLeadsBusinessRetail from "./pages/NewDashboard/MyLeadsBusinessRetail";
import NotificationPage from "./pages/Notification/NotificationPage";
import EditProfilePage from "./pages/NewDashboard/SubscriptionProfileUpdate";
import RetailTransactionInvoice from "./pages/BusinessNewPages/RetailTransactionInvoice";
import RetailDisqualifiedLeads from "./pages/NewDashboard/RetailDisqualifiedLeads";
import RetailUserInteractionsList from "./pages/NewDashboard/RetailUserInteractionsList";

function App(props) {
  // useEffect(() => {
  //   if(!props.user){
  //     const user = {
  //       email: JSON.parse(localStorage.getItem('email')),
  //       name: localStorage.getItem('name'),
  //       role: localStorage.getItem('role'),
  //     };
  //     if (!user.role) {
  //       localStorage.clear();
  //       props.setUser_(null);
  //       props.clearLoginResponse_();
  //     }
  //     props.setUser_(user)
  //   }
  // },[props.user])

  //   useEffect(() => {
  //   const role = localStorage.getItem("role");

  //   if (!props.user && role) {
  //     const user = {
  //       email: localStorage.getItem("email"),
  //       name: localStorage.getItem("name"),
  //       role,
  //     };
  //     props.setUser_(user);
  //   }
  // }, [props.user]); //orig

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("role");

    // ONLY restore user if token exists
    if (!props.user && token && role) {
      const user = {
        email: localStorage.getItem("email"),
        name: localStorage.getItem("name"),
        role,
      };
      props.setUser_(user);
    }
  }, [props.user]);

  //   if (!props.user && role) {
  //     const user = {
  //       email: JSON.parse(localStorage.getItem("email")),
  //       name: localStorage.getItem("name"),
  //       role,
  //     };
  //     props.setUser_(user);
  //   }
  // }, [props.user]);

  console.log("Redux user:", props.user);

  return (
    <>
      <Router>
        <Routes>
          <Route element={<SiderDemo />}>
            <Route path="/" element={<LeadGenerationAnalytics />} />
            <Route path="/transaction-history" element={<TransactionPage />} />
            <Route path="/my-leads" element={<MyLeads />} />
            <Route path="/my-bussiness-leads" element={<MyLeadsBusiness />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/helpdesk" element={<Helpdesk />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/upgrade-plan" element={<UpgradePlan />} />
            <Route path="/user-dashboard" element={<NewUserDashboard />} />
            <Route
              path="/user-dashboard-web"
              element={<NewUserDashboardWeb />}
            />
            <Route
              path="/user-dashboard-mobile"
              element={<NewUserDashboardMobile />}
            />
            <Route path="notification-page" element={<NotificationPage />} />
            <Route
              path="/subscription-profile-update"
              element={<EditProfilePage />}
            />
            {/* <Route path="/retail-my-leads" element={<RetailMyLeads />} /> */}
            <Route
              path="/my-leads-retail"
              element={<MyLeadsBusinessRetail />}
            />
            <Route
              path="/my-leads-retail-web"
              element={<MyLeadsBusinessRetailWeb />}
            />
            <Route
              path="/my-leads-retail-mobile"
              element={<MyLeadsBusinessRetailMobile />}
            />
            <Route
              path="/retail-transaction-history"
              element={<RetailTransactionsHistory />}
            />
            <Route path="/my-cart" element={<MyCart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failure" element={<PaymentFailure />} />
            <Route path="/user-dashboard-filter" element={<FilterLeads />} />

            <Route path="/admin">
              <Route index element={<AdminDashboard />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="leadbulkupload" element={<LeadBulkUpload />} />
              {/* <Route path="tickets" element={<Tickets />} /> */}
              <Route
                path="subscription-master"
                element={<MySubscriptiontable />}
              />
              <Route path="utm-mapping" element={<UtmMapping />} />
              <Route path="utm-mapping-form" element={<UtmMappingForm />} />
              <Route
                path="business-and-lead-mapping"
                element={<BandLMapping />}
              />
              <Route
                path="subscription-master-form"
                element={<SubscriptionMaster />}
              />
              <Route path="business-mapping" element={<Customizedplan />} />
              <Route path="new-dashboard" element={<NewDashboard />} />

              <Route path="after-login" element={<AfterLogin />} />
              <Route path="after-login-web" element={<AfterLoginWeb />} />
              <Route
                path="retail-admin-dashboard"
                element={<RetailAdminDashboard />}
              />
              <Route
                path="retail-disqualified-leads"
                element={<RetailDisqualifiedLeads />}
              />
              <Route
                path="retail-user-interactions"
                element={<RetailUserInteractionsList />}
              />
              <Route path="after-login-mobile" element={<AfterLoginMobile />} />
              <Route path="bulk-upload" element={<BulkUploadLeads />} />

              {/* <Route path="preview-cart" element={<PreviewCart />} /> */}
            </Route>
          </Route>
          <Route path="/subscription-bill/:id" element={<SubscriptionBill />} />
          <Route
            path="/admin/transactions/:id/invoice"
            element={<RetailTransactionInvoice />}
          />

          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<Finalform />} />
          {/* <Route path="before-login" element={<BeforeLogin />} /> */}
          {/* <Route path="before-login-mobile" element={<BeforeLoginMobile/>} />   */}
          <Route path="/retail-leads" element={<BeforeLogin />} />
          <Route path="/dashboard-filter" element={<FilterLeads />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* <Route path="/sign-up" element={<RegistrationPage />} /> */}
          {/* <Route path="/redirect-mail" element={<RedirectMail />} /> */}
          {/* <Route path="/password" element={<Password />} /> */}
          <Route path="/test" element={<Test />} />
        </Routes>
        <Routes></Routes>
      </Router>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.resposne, //not works for before-login-web
});
// const mapStateToProps = state => ({
//   user: state.user.response   //  correct key
// })

const mapDispatchToProps = (dispatch) => ({
  setUser_: (data) => {
    dispatch(setUser(data));
  },
  clearLoginResponse_: () => {
    dispatch({ type: "FETCH_LOGIN_CLEAR" });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
